/**
 * GraphQL APIクライアント
 * Cloud RunのGraphQLエンドポイントにリクエストを送信
 */
import axios from "axios";
import { getAPIToken } from "./firebaseAuthentication";
import { APPLICATION_NAME } from "../constant/applicationConstant";
// GraphQLエンドポイントURL（既存のAPI_URLを使用）
const GRAPHQL_ENDPOINT = `${process.env.APP_API_URL}j21spb32/graphql`;
/**
 * GraphQLでページ権限情報を取得
 * @returns ページ権限リスト
 */
export const fetchPagePermissions = async () => {
    try {
        const query = `
            query getPagePermissions {
                pagePermissions {
                    pageId
                    permissionType
                }
            }
        `;
        const response = await axios.post(GRAPHQL_ENDPOINT, { query }, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + (await getAPIToken()),
                "Application-Name": APPLICATION_NAME + "-" + process.env.ENVIRONMENT_MODE,
            }
        });
        if (response.data.errors) {
            console.error("GraphQL errors:", response.data.errors);
            throw new Error("Failed to fetch page permissions");
        }
        return response.data.data.pagePermissions || [];
    }
    catch (error) {
        console.error("ページ権限の取得に失敗しました:", error);
        throw error;
    }
};
